import { useAuth0 } from '@auth0/auth0-react';
import Fade from "@material-ui/core/Fade";
import Dialog from "@mui/material/Dialog";
import BackIcon from 'assets/icons/Back.png';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import ShareClassIcon from 'assets/icons/ShareClass.svg';
import Button from 'components/button/Button';
import AlertDialog from 'components/Dialog/index';
import PreSchoolService from 'Lib/API/PreSchool';
import ShareDocumentsModal from 'pages/NewFinance/Documents/ShareDocumentsModal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { useHistory, useLocation, useParams } from "react-router-dom";
import AddParticipantModal from './AddParticipantModal/AddParticipantModal';
import ParticipantDetailsTable from './ParticipantDetailsTable/ParticipantDetailsTable';
import { AddParticipant, ButtonGroup, ClassInfo, EditClass, Header, ShareClass, Title, Wrapper } from './Theme';

const ParticipantDetails = () => {
    const [openFilter, setOpenFilter] = useState(false)
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);

    const [loading, setLoading] = useState(false);
    const [participantsPage, setParticipantsPage] = useState(1);
    const [count, setCount] = useState();
    const [rows, setRows] = useState([]);
    const [renderCount, setRenderCount] = useState(0);
    const [openAddParticipant, setOpenAddParticipant] = useState(false);
    const [openSharePaymentModal, setOpenSharePayment] = useState(false)
    const [dataRowSharePayment, setDataRowSharePayment] = useState({})
    const [confirmClose, setConfirmClose] = useState(false);
    const [classInfo, setClassInfo] = useState({});
    const [getClassLoading, setGetClassLoading] = useState(false);


    const dispatch = useDispatch();
    const [addParticipantLoading, setAddParticipantLoading] = React.useState(false);

    const { id: classId } = useParams();
    const participantGroupId = searchParams.get("groupId");

    const [filter, setFilter] = useState({
        sort: {},
    });
    const { getAccessTokenSilently } = useAuth0();

    const getClassHandler = async () => {
        setGetClassLoading(true);
        try {
            const token = await getAccessTokenSilently();
            const response = await PreSchoolService.getClassById(token, classId);
            const data = response?.result;
            setClassInfo(data);            
        } catch (error) {
            toastr.error('Error', error?.data?.message || 'Something went wrong');
        } finally {
            setGetClassLoading(false);
        }
    };
    useEffect(() => {
        if (classId) {
            getClassHandler();
        }
    }, [classId, getAccessTokenSilently]);

    const getClassParticipants = async (page) => {
        const currentPage = page || participantsPage;

        setLoading(true);
        try {
            const token = await getAccessTokenSilently();
            const data = {
                classId,
                ...filter,
            };
            if(participantGroupId) {
                data.groupId = participantGroupId;
            }
            const response = await PreSchoolService.getClassParticipants(
                token,
                currentPage,
                30,
                data
            );
            setCount(response.payload?.pagination?.count);
            setRows(response?.payload?.data);

        } catch (error) {
            toastr.error('Error', error?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };
    const handleOpenFilter = () => {
        setOpenFilter(!openFilter)
    }
    useEffect(() => { }, [openFilter])


    const addParticipantHandler = async ({
        contactId,
        doNotCreateCharge,
        firstName,
        lastName,
    }) => {
        setAddParticipantLoading(true)
        const token = await getAccessTokenSilently();
        const payload = {
          classId,
          contactId,
          doNotCreateCharge,
        }
        PreSchoolService.addParticipantToClass(token, payload).then((response) => {
            toastr.success('Success', `${firstName} ${lastName} added to ${classInfo?.class_name}`);
            setOpenAddParticipant(false)
            getClassParticipants()
        }).catch((error) => {
          toastr.error('Error', error?.data?.message || 'Something went wrong');
        }).finally(() => {
          setAddParticipantLoading(false)
        })    
      }

    const onSharePaymentLinkClick = (row) => {
        setOpenSharePayment((prev) => !prev);
        setDataRowSharePayment(row);
    }

    const closeModal = () => {
        setConfirmClose(true);
      }
      const confirmCloseHandler = () => {
        setConfirmClose(false);
        setOpenAddParticipant(false);
      }

    return (
        <Wrapper className='mt-10'>
            <Header>
                <ClassInfo>
                    <Title><img src={BackIcon} alt='Back' onClick={() => history.push("/religious-schools")} />{classInfo?.class_name}</Title>
                    <ButtonGroup>
                        {/* <ShareClass><img src={ShareClassIcon} alt='Share-Class' /> Share class</ShareClass>
                        <EditClass><img src={EditClassIcon} alt='Edit-Class' /> Edit class</EditClass> */}
                        <Button
                            variant="primary"
                            onClick={() => {
                                setOpenAddParticipant(true)
                            }}
                        >
                            <PlusIcon />
                            <span>Add New Student</span>
                        </Button>
                    </ButtonGroup>
                </ClassInfo>
                {/* <FilterWrapper>
                    <Filter onClick={handleOpenFilter} isFilterOpen={openFilter}>
                        <img src={openFilter ? FilterWhiteIcon : FilterIcon} alt='Filter-Participant' />Filter
                    </Filter>
                    <SearchDownShift
                        items={[]}
                        name={searchValue}
                        setName={setSearchValue}
                        placeHolder="Search"
                        autoFocus
                    />
                </FilterWrapper>
                {openFilter && <PartricipantFilter openFilter={openFilter} setOpenFilter={setOpenFilter} />} */}
            </Header>
            <ParticipantDetailsTable getClassParticipants={getClassParticipants} filter={filter} setFilter={setFilter}
                setParticipantsPage={setParticipantsPage} participantsPage={participantsPage}
                count={count} setCount={setCount} rows={rows} setRows={setRows} loading={loading} classId={classId} setRenderCount={setRenderCount}
                onSharePaymentLinkClick={onSharePaymentLinkClick}
                participantGroupId={participantGroupId}
            />
            <Dialog
                className={``}
                onClose={closeModal}
                open={openAddParticipant}
                PaperProps={{
                    style: {
                      width: "500px",
                      height: "400px",
                      overflowX: "hidden",
                      borderRadius: "10px",
                    },
                  }}
                  fullWidth
                  maxWidth={"md"}
                >
                <Fade in={openAddParticipant}>
                    <AddParticipantModal  
                        closeModal={closeModal}
                        classId={classId}
                        addParticipantHandler={addParticipantHandler}
                        addParticipantLoading={addParticipantLoading}
                    />
                </Fade>
            </Dialog>
            {openSharePaymentModal &&
                <Dialog
                open={openSharePaymentModal}
                disableEnforceFocus
                onClose={() => {
                    setOpenSharePayment(false);
                }}
                PaperProps={{
                    style: {
                    width: "888px",
                    height: "637px",
                    overflowX: "hidden",
                    borderRadius: "22px",
                    },
                }}
                fullWidth
                maxWidth={"md"}
                >
                <ShareDocumentsModal
                    closeModal={() => {
                    setOpenSharePayment(false);
                    }}
                    type={'sharePaymentLink'}
                    disablePaymentLink={true}
                    accountId={dataRowSharePayment?.account?._id}
                    accountName={dataRowSharePayment?.account?.family_name}
                    participantId={dataRowSharePayment?._id}
                    defaultEmail={dataRowSharePayment?.account?.defaultEmails || []}
                    documentType="paymentLink"
                />
                </Dialog>
            }
            <AlertDialog
                open={confirmClose}
                handleClose={() => setConfirmClose(false)}
                onDecline={() => {
                setConfirmClose(false);
                }}
                onAccept={confirmCloseHandler}
                title={"Are you sure?"}
                description={"Do you want to discard the changes you made?"}
            />
        </Wrapper>
    );
};

export default ParticipantDetails;